export interface SfasTransactionFeeValues {
    ltmRevenueThresholdPercent: number | undefined;
    feePercentOnTotalFairValue: number | undefined;
    feePercentOnExcessFairValue: number | undefined;
}

export type SfasTransactionFeeErrors = Record<keyof SfasTransactionFeeValues, boolean>;

export const EMPTY_SFAS_FEE_VALUES: SfasTransactionFeeValues = {
    ltmRevenueThresholdPercent: undefined,
    feePercentOnTotalFairValue: undefined,
    feePercentOnExcessFairValue: undefined,
};

export const NO_SFAS_FEE_ERRORS: SfasTransactionFeeErrors = {
    ltmRevenueThresholdPercent: false,
    feePercentOnTotalFairValue: false,
    feePercentOnExcessFairValue: false,
};
